(function ($, global) {
    'use strict';

    var off = /iPad|iPhone|iPod/.test(navigator.userAgent) && !global.MSStream;

    function init($elements) {
        $elements
            .each(function () {
                var $element = $(this);
                var $container = $element.parent();

                $element.select2({
                    width: '100%',
                    minimumResultsForSearch: -1,
                    dropdownParent: $container
                })
            })
            .removeClass('select2-hidden-accessible')
            .addClass('select2-hidden-custom');

        if (off) {
            $elements.off('focus.select2');
        }
    }

    init($('select.form-control'));

    $(function () {

        // Ninja forms integration
        if (global.nfForms && global.Marionette) {
            var ninjaformsReady = Marionette.Object.extend({

                initialize: function () {
                    this.listenTo(nfRadio.channel('form'), 'render:view', this.nfReady);
                },

                nfReady: function (view) {
                    init($('select.form-control:not(.select2-hidden-custom)'));
                }
            });

            // Instantiate our custom controller, defined above.
            new ninjaformsReady();
        }
    });

})(jQuery, window);
